export const MARKETING_EVENT_TYPE = {
	FACEBOOK: 'facebook',
	TRAFFIC_JUNKY: 'trafficJunkie',
};

export const TRAFFIC_JUNKY_EVENTS = {
	PURCHASE: {
		actionId: '1000578951',
		pixelId: '1000578951_cpa_testing',
	},
};

export const FACEBOOK_PIXEL_ID = '962789748530321';
export const FACEBOOK_SCRIPT_ID = 'softai-facebook-pixel';

export const TRAFFIC_JUNKY_IDSYNC_SCRIPT_ID = 'softai-traffic-junky-idsync';
export const TRAFFIC_JUNKY_IDSYNC_SRC =
	'https://fl-cdn2.contentabc.com/delivery/idsync/idsync.min.js';
export const TRAFFIC_JUNKY_IDSYNC_SITE_ID = 37830;

export const TRAFFIC_JUNKY_MEMBER_ID = '1009051751';
export const TRAFFIC_JUNKY_BASE_URL = 'https://ads.trafficjunky.net/ct';
